import {RegisterType} from '../component-registry';
import {GuidedUiPromotedSuggestions} from '../../models/Guided.schema';
import {GuidedQuickLinkDetails} from '../../models/quick-link';
import {onlyMatchingSource} from '../../utils';
import {mapGuidedV2ItemToGuidedV2KeywordSuggestions} from '../mappers';
import {ChipType} from '../chips-carousel/model';
import {h} from '@stencil/core';
import type {GuidedV2FactoryState} from '../../models/ui';

export class GuidedV2PromotedSuggestions {
  /**
   * Shows the promoted keyword suggestions in the guided search.
   * @param inputData
   * @param state {GuidedV2FactoryState}
   */
  @RegisterType(GuidedUiPromotedSuggestions.type)
  render<T extends GuidedQuickLinkDetails>(
    inputData: GuidedUiPromotedSuggestions,
    state: GuidedV2FactoryState<T>,
  ) {
      const {
        itemSources,
        label,
        maxItems,
      } = inputData; //comes from configuration

      const {
        labelProvider,
        results, //the API response
        // searchTerm,
        eventEmitters,
        isMobile,
        country, language
      } = state;

      // console.log('Keyword suggestion results',results);

      const matchingResults = results
        .filter(onlyMatchingSource(itemSources))
        .slice(0, maxItems)
        .map(mapGuidedV2ItemToGuidedV2KeywordSuggestions)
    ;
    // console.log('Keyword suggestion matching items',matchingResults);

      if (matchingResults.length == 0)
        return <span data-err="Keyword suggestions list is empty"></span>;


      return <div class="guided-v2-promoted-suggestions add-selector-strength">
        <uiaas-guided-v2-chips-carousel
          class="guided-v2-subcomponent-selected-suggestions"
          terms={matchingResults.map(r => r.keywordSuggestion)}
          header={labelProvider('guided-v2.popular-searchers.label', 'Popular Searches')}
          isSelectable={false}
          chipType={ChipType.GuidedV2Suggestions}
          chipClickedSourceType={'suggestions'}
          isMobile={isMobile}
          isPromoted={true}
          country={country}
          language={language}
        ></uiaas-guided-v2-chips-carousel>
      </div>;
  }
}
